import TesPricingOverride from "../../tesPricingOverride/tesPricingOverrideUI/TesPricingOverride";
import {
  PriceValueType,
  SingleOverrideItem,
} from "../../tesPricingOverride/tesPricingOverrideAPI";
import { SupplementPriceOverridesType } from "../../../common/types/apiTypes";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { getTime } from "date-fns";

type Props = {
  editable?: boolean;
  tesId: string;
  supplementPriceOverrides: SupplementPriceOverridesType;
  onOrderTemplateChange: (
    name: string,
    value: SupplementPriceOverridesType,
  ) => void;
};

const OrderShortTesPricingOverride = ({
  editable = true,
  tesId,
  supplementPriceOverrides,
  onOrderTemplateChange,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const updateSupplementPriceOverrides = (item: SingleOverrideItem) => {
    const { key, value, unit } = item;

    const updatedSupplementPriceOverrides: SupplementPriceOverridesType = {
      ...supplementPriceOverrides,
      [key]: {
        value,
        unit: unit as PriceValueType,
      },
    };

    return updatedSupplementPriceOverrides;
  };

  const updateOrderTemplate = (
    updatedSupplementPriceOverrides: SupplementPriceOverridesType,
  ) =>
    onOrderTemplateChange(
      "supplementPriceOverrides",
      updatedSupplementPriceOverrides,
    );

  const onAdd = (item: SingleOverrideItem) => {
    const updatedSupplementPriceOverrides =
      updateSupplementPriceOverrides(item);
    updateOrderTemplate(updatedSupplementPriceOverrides);
    return true;
  };

  const onEdit = (item: SingleOverrideItem) => {
    const updatedSupplementPriceOverrides =
      updateSupplementPriceOverrides(item);
    updateOrderTemplate(updatedSupplementPriceOverrides);
    return true;
  };

  const onDelete = (key: string) => {
    const updatedSupplementPriceOverrides = { ...supplementPriceOverrides };
    delete updatedSupplementPriceOverrides[key];
    updateOrderTemplate(updatedSupplementPriceOverrides);
  };

  const modalTitle = t(
    "tesPricingOverride:editTesPricingOverride",
  ).toUpperCase();
  const modalItemSelectLabel = t("tesPricingOverride:selectItem");
  const modalItemValueLabel = t("tesPricingOverride:selectValueLabel");

  // memoized epoch to prevent additional fetch
  const epoch = useMemo(() => getTime(new Date()), []);

  return (
    <>
      <Grid item xs={3} />
      <Grid item xs={9}>
        <TesPricingOverride
          tesId={tesId}
          date={epoch}
          tesPricingOverrideItems={supplementPriceOverrides}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          onEdit={onEdit}
          onAdd={onAdd}
          onDelete={onDelete}
          modalTitle={modalTitle}
          modalItemSelectLabel={modalItemSelectLabel}
          modalItemValueLabel={modalItemValueLabel}
          tableWidth="100%"
          editable={editable}
        />
      </Grid>
    </>
  );
};

export default OrderShortTesPricingOverride;
